import React, { FC, useContext } from "react";
import Dropdown from "../../../../../ui/widgets/dropdown";
import { useMessageSource } from "react-message-source";
import { DashboardContext } from "../../../context";
import { ProductFamily } from "../../../../../context/product-context/product-family";
import {
  DropdownMenuItemProps,
  DropdownProps,
} from "../../../../../ui/widgets/dropdown/types.tsx";

interface FilterByFamilyProps {
  onSelect: DropdownProps["onSelect"];
  initialValue: ProductFamily;
}

const FilterByFamily: FC<FilterByFamilyProps> = ({
  onSelect,
  initialValue,
}: FilterByFamilyProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  const { appliedFamilies } = useContext(DashboardContext);

  const familyFilters: DropdownMenuItemProps[] = [];
  appliedFamilies.forEach((family: ProductFamily) => {
    familyFilters.push({
      value: family.name,
      children: getMessage(`${family.translationKey}.title`),
    });
  });

  return (
    <Dropdown
      label={getMessage("Dashboard.cardholderApplication.table-filter-family")}
      menuItems={familyFilters}
      onSelect={(e) => onSelect(e)}
      selectedItemValue={initialValue.name}
    />
  );
};

export default FilterByFamily;
